import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1585f3cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog_content instruction"
};
const _hoisted_2 = {
  style: {
    "width": "50%",
    "float": "left"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {
    "width": "80px",
    "margin-right": "18px"
  }
}, "设备型号:", -1));
const _hoisted_4 = {
  style: {
    "width": "50%",
    "float": "right"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {
    "width": "80px",
    "margin-right": "18px"
  }
}, "设备IMEI:", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "指令类型:", -1));
const _hoisted_7 = {
  class: "command_box"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "指令描述:", -1));
const _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_SOS = _resolveComponent("SOS");
  const _component_SetTime = _resolveComponent("SetTime");
  const _component_RemoteTerminal = _resolveComponent("RemoteTerminal");
  const _component_PositionMode = _resolveComponent("PositionMode");
  const _component_TextTTS = _resolveComponent("TextTTS");
  const _component_TransData = _resolveComponent("TransData");
  const _component_IPSetting = _resolveComponent("IPSetting");
  const _component_Textdown = _resolveComponent("Textdown");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_Eldialog = _resolveComponent("Eldialog");
  return _openBlock(), _createBlock(_component_Eldialog, _mergeProps(_ctx.$attrs, {
    visible: _ctx.show,
    "onUpdate:visible": _cache[1] || (_cache[1] = $event => _ctx.show = $event),
    title: _ctx.title,
    onConfirmOk: _ctx.confirm,
    width: "600px"
  }), {
    form: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_descriptions, {
      column: 1,
      "label-align": "left",
      align: "left"
    }, {
      default: _withCtx(() => [!_ctx.isBatchSend ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
        key: 0
      }, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createTextVNode(" " + _toDisplayString(_ctx.deviceType), 1)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createTextVNode(" " + _toDisplayString(_ctx.mdtid), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [_hoisted_6]),
        default: _withCtx(() => [_createVNode(_component_el_select, {
          style: {
            "width": "50%"
          },
          modelValue: _ctx.cmdType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.cmdType = $event)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commandTypeOptions, cmd => {
            return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
              key: cmd.value,
              label: cmd.label,
              value: cmd.value
            }, null, 8, ["label", "value"])), [[_vShow, _ctx.handleVisible(cmd)]]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _ctx.prompt ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
        key: 1
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", {
          class: "color_active",
          innerHTML: _ctx.prompt
        }, null, 8, _hoisted_9)])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_card, {
          class: "cmd_content",
          shadow: "never"
        }, {
          default: _withCtx(() => [[10].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_SOS, {
            key: 0,
            ref: "refCmd",
            mdtid: _ctx.mdtid,
            onGetStudent: _ctx.getStudent
          }, null, 8, ["mdtid", "onGetStudent"])) : [3, 4].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_SetTime, {
            key: 1,
            ref: "refCmd",
            mdtid: _ctx.mdtid
          }, null, 8, ["mdtid"])) : [99].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_RemoteTerminal, {
            key: 2,
            ref: "refCmd",
            deviceType: _ctx.deviceType,
            mdtid: _ctx.mdtid
          }, null, 8, ["deviceType", "mdtid"])) : [51].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_PositionMode, {
            key: 3,
            ref: "refCmd",
            mdtid: _ctx.mdtid
          }, null, 8, ["mdtid"])) : [26].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_TextTTS, {
            key: 4,
            ref: "refCmd",
            mdtid: _ctx.mdtid
          }, null, 8, ["mdtid"])) : [14].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_TransData, {
            key: 5,
            ref: "refCmd",
            mdtid: _ctx.mdtid
          }, null, 8, ["mdtid"])) : [8].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_IPSetting, {
            key: 6,
            ref: "refCmd",
            mdtid: _ctx.mdtid
          }, null, 8, ["mdtid"])) : [1].includes(_ctx.cmdType) ? (_openBlock(), _createBlock(_component_Textdown, {
            key: 7,
            ref: "refCmd",
            mdtid: _ctx.mdtid,
            cmdType: _ctx.cmdType
          }, null, 8, ["mdtid", "cmdType"])) : (_openBlock(), _createBlock(_component_Textdown, {
            key: 8,
            ref: "refCmd",
            cmdType: _ctx.cmdType
          }, null, 8, ["cmdType"]))]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })])]),
    footer: _withCtx(() => []),
    _: 1
  }, 16, ["visible", "title", "onConfirmOk"]);
}